var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 957"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 16,
    cy: 16.0465,
    r: 15.5,
    fill: "#1B1C1C",
    stroke: "#2ED47A"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 77",
    d: "M9.33333 17.3798L14.6667 22.0465L22.6667 9.37984",
    stroke: "#2ED47A",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.a0ef440c86aa2189b921e3b250b3e9ed.svg";
export { ForwardRef as ReactComponent };